const mediaItems = [
  {
    title: '下拉式阅读体验演示',
    desc: '告别传统翻页，一览到底的流畅阅读方式，让漫画追更更沉浸。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20sleek%20modern%20smartphone%20displaying%20a%20colorful%20manga%20page%20in%20vertical%20scroll%20mode%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20nook%20background%20with%20soft%20bokeh%2C%20clean%20minimal%20composition%2C%20warm%20orange%20and%20cream%20tones%2C%20product%20photography%20style&width=800&height=450&seq=media-card-01&orientation=landscape',
    icon: 'ri-smartphone-line',
    duration: '2分钟了解',
  },
  {
    title: '日漫专区 · 热门连载速览',
    desc: '每周精选日漫热门连载，热血、校园、奇幻题材一应俱全。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20Japanese%20manga%20volume%20covers%20arranged%20artistically%20on%20a%20wooden%20desk%2C%20warm%20natural%20lighting%20from%20window%2C%20cozy%20reading%20atmosphere%2C%20vibrant%20anime%20art%20style%20covers%2C%20clean%20composition%2C%20warm%20coral%20and%20cream%20background&width=800&height=450&seq=media-card-02&orientation=landscape',
    icon: 'ri-sun-line',
    duration: '每日更新',
  },
  {
    title: '韩漫精选 · 全彩下拉式阅读',
    desc: '高人气韩漫全彩收录，精致画风搭配下拉式阅读，视觉盛宴。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tablet%20screen%20showing%20a%20beautiful%20full%20color%20Korean%20webtoon%20in%20vertical%20scroll%20format%2C%20vibrant%20art%20style%20with%20rich%20colors%2C%20modern%20minimal%20desk%20setup%2C%20soft%20warm%20lighting%2C%20clean%20aesthetic%2C%20product%20photography&width=800&height=450&seq=media-card-03&orientation=landscape',
    icon: 'ri-palette-line',
    duration: '全彩阅读',
  },
  {
    title: '追更指南 · 如何高效追漫',
    desc: '掌握追更技巧，不错过任何一部心仪漫画的最新话更新通知。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cozy%20evening%20reading%20scene%20with%20a%20person%20holding%20a%20phone%20displaying%20manga%2C%20warm%20lamp%20light%2C%20comfortable%20armchair%2C%20soft%20blanket%2C%20peaceful%20atmosphere%2C%20warm%20orange%20and%20cream%20tones%2C%20lifestyle%20photography&width=800&height=450&seq=media-card-04&orientation=landscape',
    icon: 'ri-compass-line',
    duration: '追更技巧',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            通过视频快速了解下拉式漫画阅读的独特魅力，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 shadow-lg">
                    <i className={`${item.icon} text-xl text-primary-500`}></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-3 py-1 rounded-full bg-foreground-950/60 text-background-50 text-xs backdrop-blur-sm">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}